import { render, staticRenderFns } from "./HomeMenu.vue?vue&type=template&id=2c8d4d06&"
import script from "./HomeMenu.vue?vue&type=script&lang=js&"
export * from "./HomeMenu.vue?vue&type=script&lang=js&"
import style0 from "./HomeMenu.vue?vue&type=style&index=0&id=2c8d4d06&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports